"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESiteType = void 0;
exports.getSiteType = getSiteType;
let ESiteType = exports.ESiteType = /*#__PURE__*/function (ESiteType) {
  ESiteType["desktop"] = "desktop";
  ESiteType["mobile"] = "mobile";
  ESiteType["tablet"] = "tablet";
  return ESiteType;
}({});
/** Утилита для отправки корректного page.siteType в аналитику */
function getSiteType(deviceType) {
  return deviceType === 'phone' ? ESiteType.mobile : ESiteType[deviceType];
}